import React, { Component } from "react";

export default class ProjectToTop extends Component {
	
	constructor(){
		super()
		this.state = {
			exterior: 	true
		}
	}
    
    handleScroll(evt) { 
	    evt.preventDefault();
	    window.scroll({
			top: 0,
			behavior: "smooth"
  		});
    }
  	
	render () {
										
	    return (
		    
			<div className="c-project__back-to-top">
				<a href="#" className="c-project__back-to-top__button" onClick={this.handleScroll} dangerouslySetInnerHTML={{__html:'<svg width="6" height="28" viewBox="0 0 6 28"><path d="M3 0L0.113249 5H5.88675L3 0ZM3.5 28L3.5 4.5H2.5L2.5 28H3.5Z" fill="black"/></svg>Back to top'}}></a>
			</div>
			
		)
	}
}
